module.exports = __webpack_public_path__ + "img/brit-bennett.ad6328eb.png";